// src/constants/Path.ts
export enum Path {
  STUDENTS = '/students',
  PROFILE = '/profile',
  MY_LISTS = '/my-lists',
  WORDS_LIST = '/words-lists',
  WORDS_LIST_ITEM = '/words-lists/:id',
  // Nie pod `/words-lists/…` — kolidowałoby z `/words-lists/:id`
  CATALOG = '/catalog',
  LETTERS = '/letters',
  REPEAT = '/repeat',
  FIND = '/find',
  PICK = '/pick',
  MEMORY = '/memory',
  PAIRING = '/pairing',
  RECOGNIZE = '/recognize',
  RECOGNIZE2 = '/recognize2',
  WRITING = '/writing',
  // Gry Easy — osobne kopie gier z grupy Regular; Literuj odwrotnie: w Regular jest kopia gry z Easy
  KIDDO_REPEAT = '/kiddo/repeat',
  KIDDO_FIND = '/kiddo/find',
  KIDDO_PICK = '/kiddo/pick',
  KIDDO_PAIRING = '/kiddo/pairing',
  KIDDO_MEMORY = '/kiddo/memory',
  KIDDO_RECOGNIZE = '/kiddo/recognize',
  KIDDO_RECOGNIZE2 = '/kiddo/recognize2',
  KIDDO_DRAGLETTERS = '/kiddo/drag-letters',
  KIDDO_WRITING = '/kiddo/writing',
  KIDDO_LETTERS = '/kiddo/letters',
  PRIVACY_POLICY = '/privacy-policy',
  TERMS_AND_CONDITIONS = '/terms-and-conditions',
  CONTACT = '/contact',
  // PUBLIC
  HOME = '/',
  LOGIN = '/login',
  ACTIVATE_TEACHER = '/activate/teacher/:token',
  // when on localhost (!)
  // ACTIVATE_STUDENT = '/activate/student/:token',
  // when on server (!!!)
  ACTIVATE_STUDENT = '/login/activate/student/:token',
  // Link do nowego hasła, który nauczyciel wysyła uczniowi — ta sama strona co aktywacja
  NEW_PASSWORD = '/login/new-password/:token',
  SIGN_UP = '/sign-up',
  SIGN_UP_CONFIRM = '/sign-up-confirm',
  RESET_PASSWORD = '/reset-password',
}

export const getWordsListLink = (wordsListId: number): Path => (
  Path.WORDS_LIST_ITEM.replace(':id', wordsListId ? wordsListId.toString() : '') as Path
);

export default Path;
